import { axiosWrapperService } from "@/services/auth/axios-wrapper-service";
import { formatErrorMessage } from "@/utils/messageFormatter";

const state = () => {
  return {
    busy: true,
    lnGenericFollowUpNotes: []
  };
};

// getters
const getters = {
  busy: state => state.busy,
  lnGenericFollowUpNotes: state => state.lnGenericFollowUpNotes
};

// actions
const actions = {
  getGenericFollowUpOnLoan: async ({ commit, dispatch }, applicationId) => {
    commit("setBusy");
    axiosWrapperService
      .axiosGet("/getGenericFollowUpOnLoan/" + applicationId)
      .then(response => {
        commit("setLnGenericFollowUpNotes", response.data.data);
      })
      .catch(error => {
        dispatch(
          "globalToastMessage/showSimpleToast",
          { message: formatErrorMessage(error), type: "error" },
          { root: true }
        );
      })
      .finally(() => {
        commit("resetBusy");
      });
  }
};

// mutations
const mutations = {
  setBusy(state) {
    state.busy = true;
  },
  resetBusy(state) {
    state.busy = false;
  },
  setLnGenericFollowUpNotes(state, lnGenericFollowUpNotes) {
    state.lnGenericFollowUpNotes = lnGenericFollowUpNotes;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
